(() => {
  const root = document.querySelector('[data-brick-catch-up]');
  if (!root) return;
  const slotsEl = root.querySelector('[data-catch-up-slots]');
  const addButton = root.querySelector('[data-catch-up-add]');
  const buyButton = root.querySelector('[data-catch-up-buy]');
  const priceEl = root.querySelector('[data-catch-up-price]');
  const statusEl = root.querySelector('[data-catch-up-status]');
  const products = JSON.parse(root.querySelector('[data-catch-up-products]').textContent || '[]');
  const minimum = Number(root.dataset.minimum) || 3;
  const maximum = Number(root.dataset.maximum) || 8;
  const currency = root.dataset.currency || 'GBP';
  let rows = Array.from({ length: minimum }, () => ({ productId: '', variantId: '' }));
  let busy = false;
  let requestError = '';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100);
  const productFor = row => products.find(p => String(p.id) === row.productId);
  const variantFor = row => productFor(row)?.variants.find(v => String(v.id) === row.variantId);
  const stockAvailable = (variant, idx) => {
    if (!variant.available) return false;
    if (!variant.inventoryManagement || variant.inventoryPolicy === 'continue') return true;
    const others = rows.filter((row, i) => i !== idx && row.variantId === String(variant.id)).length;
    return variant.inventoryQuantity > others;
  };
  const selection = (placeholder, value, options, disabled, onChange) => {
    const el = document.createElement('select');
    el.className = 'brick-catch-up__select';
    el.setAttribute('aria-label', placeholder);
    el.disabled = disabled;
    const empty = document.createElement('option'); empty.value = ''; empty.textContent = placeholder; el.appendChild(empty);
    for (const opt of options) {
      const item = document.createElement('option'); item.value = String(opt.id); item.textContent = opt.title;
      item.disabled = opt.disabled || false; el.appendChild(item);
    }
    el.value = value;
    el.addEventListener('change', () => onChange(el.value));
    return el;
  };
  const validate = () => {
    if (!products.length) return 'No eligible back issues available. Check the collection setting.';
    if (rows.length < minimum) return `Choose at least ${minimum} magazines.`;
    if (rows.some(row => !variantFor(row))) return `Select an edition and cover for all ${rows.length} magazines.`;
    if (rows.some((row, i) => !stockAvailable(variantFor(row), i))) return 'A selected cover is no longer available in that quantity.';
    return '';
  };
  const media = root.querySelector('.brick-catch-up__media');
  const stack = document.createElement('div');
  stack.className = 'brick-catch-up__stack';
  stack.setAttribute('aria-label', 'Your selected magazine covers');
  media.appendChild(stack);
  const renderStack = () => {
    const selected = rows.map((row, index) => {
      const product = productFor(row);
      const cover = variantFor(row);
      return cover?.image ? { product, cover, index } : null;
    }).filter(Boolean);
    media.classList.toggle('has-stack', selected.length > 0);
    const layers = selected.map(({ product, cover, index }, layer) => {
      const image = document.createElement('img');
      image.className = 'brick-catch-up__stack-cover';
      image.src = cover.image;
      image.alt = 'Mag ' + (index + 1) + ': ' + product.title + ' — ' + cover.title;
      image.width = 800; image.height = 1000;
      image.style.setProperty('--stack-x', (selected.length === 1 ? 6 : 12 - layer * Math.min(5, 24 / (selected.length - 1))) + '%');
      image.style.setProperty('--stack-angle', [6, -4, 3, -6, 5, -2, 4, -5, 2, -3, 6, -1][layer] + 'deg');
      image.style.zIndex = layer + 1;
      return image;
    });
    stack.replaceChildren(...layers);
  };
  const render = () => {
    renderStack();
    slotsEl.replaceChildren();
    rows.forEach((row, idx) => {
      const wrap = document.createElement('div'); wrap.className = 'brick-catch-up__slot';
      const header = document.createElement('div'); header.className = 'brick-catch-up__slot-header';
      const label = document.createElement('span'); label.textContent = `Mag ${idx + 1}:`; header.appendChild(label);
      if (rows.length > minimum) {
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'brick-catch-up__remove'; remove.textContent = 'REMOVE';
        remove.setAttribute('aria-label', `Remove magazine ${idx + 1}`);
        remove.addEventListener('click', () => { rows.splice(idx, 1); render(); }); header.appendChild(remove);
      }
      wrap.appendChild(header);
      wrap.appendChild(selection('SELECT EDITION', row.productId, products.map(p => ({ id: p.id, title: p.title, disabled: !p.variants.some(v => stockAvailable(v, idx)) })), busy, id => {
        rows[idx] = { productId: id, variantId: '' }; render();
      }));
      const p = productFor(row);
      wrap.appendChild(selection('SELECT COVER', row.variantId, p ? p.variants.map(v => ({ id: v.id, title: v.title === 'Default Title' ? 'STANDARD COVER' : v.title, disabled: !stockAvailable(v, idx) })) : [], busy || !p, id => {
        rows[idx].variantId = id; render();
      }));
      slotsEl.appendChild(wrap);
    });
    addButton.hidden = rows.length >= maximum;
    addButton.disabled = busy;
    const validCount = rows.filter(row => variantFor(row)).length;
    // The offer is 50% off the selected source variants when the Shopify automatic discount qualifies.
    const total = rows.reduce((sum, row) => sum + (variantFor(row)?.price || 0), 0);
    priceEl.textContent = money(Math.round(total / 2));
    const message = validate();
    buyButton.disabled = !!message || busy;
    buyButton.textContent = busy ? 'ADDING…' : 'ADD TO CART';
    statusEl.textContent = requestError || message || '';
    if (!validCount) priceEl.textContent = '—';
  };
  addButton.addEventListener('click', () => { if (rows.length < maximum && !busy) { rows.push({ productId: '', variantId: '' }); render(); } });
  buyButton.addEventListener('click', async () => {
    if (busy || validate()) return;
    requestError = ''; busy = true; render();
    try {
      const quantities = new Map();
      rows.forEach(row => quantities.set(row.variantId, (quantities.get(row.variantId) || 0) + 1));
      const route = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${route}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id: Number(id), quantity })) })
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || result.message || 'Unable to add these magazines to your bag.');
      }
      if (window.brickCart) { await window.brickCart.refresh(); window.brickCart.open(); }
      else window.location.assign(`${route}cart`);
      requestError = ''; 
    } catch (error) { requestError = error.message; }
    finally { busy = false; render(); }
  });
  render();
})();
